import { render } from "./ItemizedList.vue?vue&type=template&id=2ac584de"
import script from "./ItemizedList.vue?vue&type=script&lang=js"
export * from "./ItemizedList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__